import { compareTo3ankvs086tmwq as compareTo } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  toNumber2e2hj9zugjwi2 as toNumber,
  fromInt2ii0rejb1w62w as fromInt,
  dividelr0uqtdj497z as divide,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { InlineClassDescriptor2odlvyasjrmr0 as InlineClassDescriptor } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/InlineClassDescriptor.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  LongSerializer_getInstancepwtz4tlewrfw as LongSerializer_getInstance,
  DoubleSerializer_getInstance1tuvibnyg07o1 as DoubleSerializer_getInstance,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import {
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  getBigIntHashCode294hi5bdhtj6e as getBigIntHashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Comparable198qfk8pnblz0 as Comparable } from '../../../../../kotlin-kotlin-stdlib/kotlin/Comparable.mjs';
import { rangeUntilvkeu8z37zujo as rangeUntil } from '../../../../../kotlin-kotlin-stdlib/kotlin/ranges/Ranges.mjs';
import { getNumberHashCode2l4nbdcihl25f as getNumberHashCode } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/bitUtils.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function _DataSize___init__impl__iz9cfq(bytes) {
  return bytes;
}
function _DataSize___get_bytes__impl__nlgkc0($this) {
  return $this;
}
function DataSize__compareTo_impl_owgpm0($this, other) {
  return compareTo(_DataSize___get_bytes__impl__nlgkc0($this), _DataSize___get_bytes__impl__nlgkc0(other));
}
function DataSize__compareTo_impl_owgpm0_0($this, other) {
  return DataSize__compareTo_impl_owgpm0($this.bytes_1, other instanceof DataSize() ? other.bytes_1 : THROW_CCE());
}
function _DataSize___get_kibibytes__impl__da5jmd($this) {
  return toNumber(_DataSize___get_bytes__impl__nlgkc0($this)) / 1024;
}
function _DataSize___get_mebibytes__impl__wavpgx($this) {
  return toNumber(_DataSize___get_bytes__impl__nlgkc0($this)) / 1024 / 1024;
}
function _DataSize___get_gibibytes__impl__nz4fl3($this) {
  return toNumber(_DataSize___get_bytes__impl__nlgkc0($this)) / 1024 / 1024 / 1024;
}
function _DataSize___get_tebibytes__impl__kdhac8($this) {
  return toNumber(_DataSize___get_bytes__impl__nlgkc0($this)) / 1024 / 1024 / 1024 / 1024;
}
function _DataSize___get_decimalKilobytes__impl__rjupzq($this) {
  return toNumber(_DataSize___get_bytes__impl__nlgkc0($this)) / 1000;
}
function _DataSize___get_decimalMegabytes__impl__yffmh1($this) {
  return toNumber(_DataSize___get_bytes__impl__nlgkc0($this)) / 1000 / 1000;
}
function _DataSize___get_decimalGigabytes__impl__q3ocl7($this) {
  return toNumber(_DataSize___get_bytes__impl__nlgkc0($this)) / 1000 / 1000 / 1000;
}
function _DataSize___get_decimalTerabytes__impl__rl89rd($this) {
  return toNumber(_DataSize___get_bytes__impl__nlgkc0($this)) / 1000 / 1000 / 1000 / 1000;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
function DataSize__toString_impl_z6j16e($this) {
  return DataSize__toStringBinaryAbbreviated_impl_fe01fw($this);
}
function DataSize__toStringBinaryAbbreviated_impl_fe01fw($this) {
  var amount = _DataSize___get_bytes__impl__nlgkc0($this);
  if (amount > 1024n) {
    // Inline function 'kotlin.Long.div' call
    var this_0 = amount;
    amount = divide(this_0, fromInt(1024));
  } else
    return amount.toString() + ' B';
  if (amount > 1024n) {
    // Inline function 'kotlin.Long.div' call
    var this_1 = amount;
    amount = divide(this_1, fromInt(1024));
  } else
    return amount.toString() + ' KiB';
  if (amount > 1024n) {
    // Inline function 'kotlin.Long.div' call
    var this_2 = amount;
    amount = divide(this_2, fromInt(1024));
  } else
    return amount.toString() + ' MiB';
  if (amount > 1024n) {
    // Inline function 'kotlin.Long.div' call
    var this_3 = amount;
    amount = divide(this_3, fromInt(1024));
  } else
    return amount.toString() + ' GiB';
  return amount.toString() + ' TiB';
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (InlineClassDescriptor())('com.lightningkite.services.data.DataSize', this);
        tmp0_serialDesc.addElement_5pzumi_k$('bytes', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_a9n7od_k$(encoder, value) {
        var tmp0_inlineEncoder = encoder.encodeInline_wxp5pu_k$(this.descriptor_1);
        if (tmp0_inlineEncoder == null)
          null;
        else {
          tmp0_inlineEncoder.encodeLong_vlw3uq_k$(_DataSize___get_bytes__impl__nlgkc0(value));
        }
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_a9n7od_k$(encoder, value instanceof DataSize() ? value.bytes_1 : THROW_CCE());
      }
      deserialize_xxgef5_k$(decoder) {
        return _DataSize___init__impl__iz9cfq(decoder.decodeInline_ux3vza_k$(this.descriptor_1).decodeLong_jzt186_k$());
      }
      deserialize_sy6x50_k$(decoder) {
        return new (DataSize())(this.deserialize_xxgef5_k$(decoder));
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [LongSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
function DataSize__hashCode_impl_dfd4dj($this) {
  return getBigIntHashCode($this);
}
function DataSize__equals_impl_w4ewsd($this, other) {
  if (!(other instanceof DataSize()))
    return false;
  if (!($this === other.bytes_1))
    return false;
  return true;
}
var DataSizeClass;
function DataSize() {
  if (DataSizeClass === VOID) {
    class $ {
      constructor(bytes) {
        this.bytes_1 = bytes;
      }
      compareTo_otps80_k$(other) {
        return DataSize__compareTo_impl_owgpm0(this.bytes_1, other);
      }
      compareTo_hpufkf_k$(other) {
        return DataSize__compareTo_impl_owgpm0_0(this, other);
      }
      toString() {
        return DataSize__toString_impl_z6j16e(this.bytes_1);
      }
      hashCode() {
        return DataSize__hashCode_impl_dfd4dj(this.bytes_1);
      }
      equals(other) {
        return DataSize__equals_impl_w4ewsd(this.bytes_1, other);
      }
    }
    initMetadataForClass($, 'DataSize', VOID, VOID, [Comparable()], VOID, VOID, {0: $serializer_getInstance});
    DataSizeClass = $;
  }
  return DataSizeClass;
}
function _Length___init__impl__mrryhn(meters) {
  return meters;
}
function _Length___get_meters__impl__co03t8($this) {
  return $this;
}
function Length__compareTo_impl_4hbpn1($this, other) {
  return compareTo(_Length___get_meters__impl__co03t8($this), _Length___get_meters__impl__co03t8(other));
}
function Length__compareTo_impl_4hbpn1_0($this, other) {
  return Length__compareTo_impl_4hbpn1($this.meters_1, other instanceof Length() ? other.meters_1 : THROW_CCE());
}
function _Length___get_centimeters__impl__ltzset($this) {
  return _Length___get_meters__impl__co03t8($this) / 0.01;
}
function _Length___get_feet__impl__kw6lw0($this) {
  return _Length___get_meters__impl__co03t8($this) / 0.3048;
}
function _Length___get_inches__impl__de09ru($this) {
  return _Length___get_meters__impl__co03t8($this) / 0.025400000000000002;
}
function _Length___get_kilometers__impl__syiikt($this) {
  return _Length___get_meters__impl__co03t8($this) / 1000.0;
}
function _Length___get_lightYears__impl__sob8wy($this) {
  return _Length___get_meters__impl__co03t8($this) / 9.4607304725808E15;
}
function _Length___get_micrometer__impl__xab82h($this) {
  return _Length___get_meters__impl__co03t8($this) / 1.0E-6;
}
function _Length___get_miles__impl__iwi6te($this) {
  return _Length___get_meters__impl__co03t8($this) / 1609.344;
}
function _Length___get_millimeter__impl__i75bku($this) {
  return _Length___get_meters__impl__co03t8($this) / 0.001;
}
function _Length___get_nanometer__impl__86nsy3($this) {
  return _Length___get_meters__impl__co03t8($this) / 1.0E-9;
}
function _Length___get_yards__impl__8j9pnr($this) {
  return _Length___get_meters__impl__co03t8($this) / 0.9144;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      get_miles_tb1bul_k$(_this__u8e3s4) {
        return _Length___init__impl__mrryhn(_this__u8e3s4 * 1609.344);
      }
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_0();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  return Companion_instance_0;
}
function Length__toString_impl_qoaji3($this) {
  return Length__toStringMetric_impl_bnt6hh($this);
}
function Length__toStringMetric_impl_bnt6hh($this) {
  var tmp0_subject = _Length___get_meters__impl__co03t8($this);
  return rangeUntil(0.0, 1.0E-7).contains_3tkdvy_k$(tmp0_subject) ? '' + _Length___get_nanometer__impl__86nsy3($this) + ' nm' : rangeUntil(1.0E-7, 1.0E-5).contains_3tkdvy_k$(tmp0_subject) ? '' + _Length___get_micrometer__impl__xab82h($this) + ' mm' : rangeUntil(1.0E-4, 0.01).contains_3tkdvy_k$(tmp0_subject) ? '' + _Length___get_millimeter__impl__i75bku($this) + ' mm' : rangeUntil(0.01, 1.0).contains_3tkdvy_k$(tmp0_subject) ? '' + _Length___get_centimeters__impl__ltzset($this) + ' cm' : rangeUntil(1.0, 1000.0).contains_3tkdvy_k$(tmp0_subject) ? '' + _Length___get_meters__impl__co03t8($this) + ' m' : rangeUntil(1000.0, 9.4607304725808E13).contains_3tkdvy_k$(tmp0_subject) ? '' + _Length___get_kilometers__impl__syiikt($this) + ' km' : '' + _Length___get_lightYears__impl__sob8wy($this) + ' ly';
}
var $serializerClass_0;
function $serializer_0() {
  if ($serializerClass_0 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_0 = this;
        var tmp0_serialDesc = new (InlineClassDescriptor())('com.lightningkite.services.data.Length', this);
        tmp0_serialDesc.addElement_5pzumi_k$('meters', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_d5d7vi_k$(encoder, value) {
        var tmp0_inlineEncoder = encoder.encodeInline_wxp5pu_k$(this.descriptor_1);
        if (tmp0_inlineEncoder == null)
          null;
        else {
          tmp0_inlineEncoder.encodeDouble_n270q9_k$(_Length___get_meters__impl__co03t8(value));
        }
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_d5d7vi_k$(encoder, value instanceof Length() ? value.meters_1 : THROW_CCE());
      }
      deserialize_46b3hg_k$(decoder) {
        return _Length___init__impl__mrryhn(decoder.decodeInline_ux3vza_k$(this.descriptor_1).decodeDouble_ur8l0f_k$());
      }
      deserialize_sy6x50_k$(decoder) {
        return new (Length())(this.deserialize_46b3hg_k$(decoder));
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [DoubleSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_0 = $;
  }
  return $serializerClass_0;
}
var $serializer_instance_0;
function $serializer_getInstance_0() {
  if ($serializer_instance_0 === VOID)
    new ($serializer_0())();
  return $serializer_instance_0;
}
function Length__hashCode_impl_4x4mp8($this) {
  return getNumberHashCode($this);
}
function Length__equals_impl_odc88o($this, other) {
  if (!(other instanceof Length()))
    return false;
  var tmp0_other_with_cast = other.meters_1;
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
var LengthClass;
function Length() {
  if (LengthClass === VOID) {
    class $ {
      constructor(meters) {
        this.meters_1 = meters;
      }
      compareTo_hxexp7_k$(other) {
        return Length__compareTo_impl_4hbpn1(this.meters_1, other);
      }
      compareTo_hpufkf_k$(other) {
        return Length__compareTo_impl_4hbpn1_0(this, other);
      }
      toString() {
        return Length__toString_impl_qoaji3(this.meters_1);
      }
      hashCode() {
        return Length__hashCode_impl_4x4mp8(this.meters_1);
      }
      equals(other) {
        return Length__equals_impl_odc88o(this.meters_1, other);
      }
    }
    initMetadataForClass($, 'Length', VOID, VOID, [Comparable()], VOID, VOID, {0: $serializer_getInstance_0});
    LengthClass = $;
  }
  return LengthClass;
}
function _Area___init__impl__ijsx70(squareMeters) {
  return squareMeters;
}
function _Area___get_squareMeters__impl__tdkp4u($this) {
  return $this;
}
function Area__compareTo_impl_udkzyy($this, other) {
  return compareTo(_Area___get_squareMeters__impl__tdkp4u($this), _Area___get_squareMeters__impl__tdkp4u(other));
}
function Area__compareTo_impl_udkzyy_0($this, other) {
  return Area__compareTo_impl_udkzyy($this.squareMeters_1, other instanceof Area() ? other.squareMeters_1 : THROW_CCE());
}
function _Area___get_acres__impl__gakf2d($this) {
  return _Area___get_squareMeters__impl__tdkp4u($this) / 4046.8564224;
}
function _Area___get_hectare__impl__ftwe8j($this) {
  return _Area___get_squareMeters__impl__tdkp4u($this) / 10000.0;
}
function _Area___get_squareKilometers__impl__3iiltv($this) {
  return _Area___get_squareMeters__impl__tdkp4u($this) / 1000000.0;
}
function _Area___get_squareMillimeters__impl__fkxnwh($this) {
  return _Area___get_squareMeters__impl__tdkp4u($this) / 1.0E-6;
}
function _Area___get_squareCentimeters__impl__t9odvv($this) {
  return _Area___get_squareMeters__impl__tdkp4u($this) / 1.0E-4;
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_1();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_1;
function Companion_getInstance_1() {
  return Companion_instance_1;
}
function Area__toString_impl_owfsr0($this) {
  return '' + _Area___get_squareMeters__impl__tdkp4u($this) + ' m^2';
}
var $serializerClass_1;
function $serializer_1() {
  if ($serializerClass_1 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_1 = this;
        var tmp0_serialDesc = new (InlineClassDescriptor())('com.lightningkite.services.data.Area', this);
        tmp0_serialDesc.addElement_5pzumi_k$('squareMeters', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_e2od23_k$(encoder, value) {
        var tmp0_inlineEncoder = encoder.encodeInline_wxp5pu_k$(this.descriptor_1);
        if (tmp0_inlineEncoder == null)
          null;
        else {
          tmp0_inlineEncoder.encodeDouble_n270q9_k$(_Area___get_squareMeters__impl__tdkp4u(value));
        }
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_e2od23_k$(encoder, value instanceof Area() ? value.squareMeters_1 : THROW_CCE());
      }
      deserialize_z6xcu5_k$(decoder) {
        return _Area___init__impl__ijsx70(decoder.decodeInline_ux3vza_k$(this.descriptor_1).decodeDouble_ur8l0f_k$());
      }
      deserialize_sy6x50_k$(decoder) {
        return new (Area())(this.deserialize_z6xcu5_k$(decoder));
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [DoubleSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_1 = $;
  }
  return $serializerClass_1;
}
var $serializer_instance_1;
function $serializer_getInstance_1() {
  if ($serializer_instance_1 === VOID)
    new ($serializer_1())();
  return $serializer_instance_1;
}
function Area__hashCode_impl_odicf9($this) {
  return getNumberHashCode($this);
}
function Area__equals_impl_8gtmo1($this, other) {
  if (!(other instanceof Area()))
    return false;
  var tmp0_other_with_cast = other.squareMeters_1;
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
var AreaClass;
function Area() {
  if (AreaClass === VOID) {
    class $ {
      constructor(squareMeters) {
        this.squareMeters_1 = squareMeters;
      }
      compareTo_m8umzi_k$(other) {
        return Area__compareTo_impl_udkzyy(this.squareMeters_1, other);
      }
      compareTo_hpufkf_k$(other) {
        return Area__compareTo_impl_udkzyy_0(this, other);
      }
      toString() {
        return Area__toString_impl_owfsr0(this.squareMeters_1);
      }
      hashCode() {
        return Area__hashCode_impl_odicf9(this.squareMeters_1);
      }
      equals(other) {
        return Area__equals_impl_8gtmo1(this.squareMeters_1, other);
      }
    }
    initMetadataForClass($, 'Area', VOID, VOID, [Comparable()], VOID, VOID, {0: $serializer_getInstance_1});
    AreaClass = $;
  }
  return AreaClass;
}
function _Volume___init__impl__tjrqop(cubicMeters) {
  return cubicMeters;
}
function _Volume___get_cubicMeters__impl__6kaaeg($this) {
  return $this;
}
function Volume__compareTo_impl_e47i3d($this, other) {
  return compareTo(_Volume___get_cubicMeters__impl__6kaaeg($this), _Volume___get_cubicMeters__impl__6kaaeg(other));
}
function Volume__compareTo_impl_e47i3d_0($this, other) {
  return Volume__compareTo_impl_e47i3d($this.cubicMeters_1, other instanceof Volume() ? other.cubicMeters_1 : THROW_CCE());
}
function _Volume___get_cubicFeet__impl__wre3yk($this) {
  return _Volume___get_cubicMeters__impl__6kaaeg($this) / 0.028316846592000004;
}
function _Volume___get_cups__impl__tqhzrx($this) {
  return _Volume___get_cubicMeters__impl__6kaaeg($this) / 2.365882365000001E-4;
}
function _Volume___get_gallons__impl__smxhou($this) {
  return _Volume___get_cubicMeters__impl__6kaaeg($this) / 0.0037854117840000014;
}
function _Volume___get_liquidOunces__impl__d78jyr($this) {
  return _Volume___get_cubicMeters__impl__6kaaeg($this) / 2.957352956250001E-5;
}
function _Volume___get_liters__impl__yw6tct($this) {
  return _Volume___get_cubicMeters__impl__6kaaeg($this) / 0.001;
}
function _Volume___get_milliliters__impl__2fzycw($this) {
  return _Volume___get_cubicMeters__impl__6kaaeg($this) / 1.0E-6;
}
function _Volume___get_pints__impl__mv7688($this) {
  return _Volume___get_cubicMeters__impl__6kaaeg($this) / 4.731764730000002E-4;
}
function _Volume___get_quarts__impl__2w1hjy($this) {
  return _Volume___get_cubicMeters__impl__6kaaeg($this) / 9.463529460000004E-4;
}
var CompanionClass_2;
function Companion_2() {
  if (CompanionClass_2 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_2();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_2 = $;
  }
  return CompanionClass_2;
}
var Companion_instance_2;
function Companion_getInstance_2() {
  return Companion_instance_2;
}
function Volume__toString_impl_ewnyiv($this) {
  return '' + _Volume___get_cubicMeters__impl__6kaaeg($this) + ' m\xB3';
}
var $serializerClass_2;
function $serializer_2() {
  if ($serializerClass_2 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_2 = this;
        var tmp0_serialDesc = new (InlineClassDescriptor())('com.lightningkite.services.data.Volume', this);
        tmp0_serialDesc.addElement_5pzumi_k$('cubicMeters', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_68uqlq_k$(encoder, value) {
        var tmp0_inlineEncoder = encoder.encodeInline_wxp5pu_k$(this.descriptor_1);
        if (tmp0_inlineEncoder == null)
          null;
        else {
          tmp0_inlineEncoder.encodeDouble_n270q9_k$(_Volume___get_cubicMeters__impl__6kaaeg(value));
        }
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_68uqlq_k$(encoder, value instanceof Volume() ? value.cubicMeters_1 : THROW_CCE());
      }
      deserialize_pm2mo_k$(decoder) {
        return _Volume___init__impl__tjrqop(decoder.decodeInline_ux3vza_k$(this.descriptor_1).decodeDouble_ur8l0f_k$());
      }
      deserialize_sy6x50_k$(decoder) {
        return new (Volume())(this.deserialize_pm2mo_k$(decoder));
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [DoubleSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_2 = $;
  }
  return $serializerClass_2;
}
var $serializer_instance_2;
function $serializer_getInstance_2() {
  if ($serializer_instance_2 === VOID)
    new ($serializer_2())();
  return $serializer_instance_2;
}
function Volume__hashCode_impl_6uhya0($this) {
  return getNumberHashCode($this);
}
function Volume__equals_impl_226xkc($this, other) {
  if (!(other instanceof Volume()))
    return false;
  var tmp0_other_with_cast = other.cubicMeters_1;
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
var VolumeClass;
function Volume() {
  if (VolumeClass === VOID) {
    class $ {
      constructor(cubicMeters) {
        this.cubicMeters_1 = cubicMeters;
      }
      compareTo_edobht_k$(other) {
        return Volume__compareTo_impl_e47i3d(this.cubicMeters_1, other);
      }
      compareTo_hpufkf_k$(other) {
        return Volume__compareTo_impl_e47i3d_0(this, other);
      }
      toString() {
        return Volume__toString_impl_ewnyiv(this.cubicMeters_1);
      }
      hashCode() {
        return Volume__hashCode_impl_6uhya0(this.cubicMeters_1);
      }
      equals(other) {
        return Volume__equals_impl_226xkc(this.cubicMeters_1, other);
      }
    }
    initMetadataForClass($, 'Volume', VOID, VOID, [Comparable()], VOID, VOID, {0: $serializer_getInstance_2});
    VolumeClass = $;
  }
  return VolumeClass;
}
function _Mass___init__impl__g55pzh(kilograms) {
  return kilograms;
}
function _Mass___get_kilograms__impl__lr3pd5($this) {
  return $this;
}
function Mass__compareTo_impl_3ilym9($this, other) {
  return compareTo(_Mass___get_kilograms__impl__lr3pd5($this), _Mass___get_kilograms__impl__lr3pd5(other));
}
function Mass__compareTo_impl_3ilym9_0($this, other) {
  return Mass__compareTo_impl_3ilym9($this.kilograms_1, other instanceof Mass() ? other.kilograms_1 : THROW_CCE());
}
function _Mass___get_grams__impl__rxyb9m($this) {
  return _Mass___get_kilograms__impl__lr3pd5($this) / 0.001;
}
function _Mass___get_milligrams__impl__s8wiar($this) {
  return _Mass___get_kilograms__impl__lr3pd5($this) / 1.0E-6;
}
function _Mass___get_pounds__impl__r7075n($this) {
  return _Mass___get_kilograms__impl__lr3pd5($this) / 0.45359237;
}
function _Mass___get_tonnes__impl__aj2kxp($this) {
  return _Mass___get_kilograms__impl__lr3pd5($this) / 1000.0;
}
function _Mass___get_tons__impl__so9xvw($this) {
  return _Mass___get_kilograms__impl__lr3pd5($this) / 907.18474;
}
function _Mass___get_weightOunces__impl__w4i8hh($this) {
  return _Mass___get_kilograms__impl__lr3pd5($this) / 0.028349523125;
}
var CompanionClass_3;
function Companion_3() {
  if (CompanionClass_3 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_3();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_3 = $;
  }
  return CompanionClass_3;
}
var Companion_instance_3;
function Companion_getInstance_3() {
  return Companion_instance_3;
}
function Mass__toString_impl_yxkxoz($this) {
  return '' + _Mass___get_kilograms__impl__lr3pd5($this) + ' kg';
}
var $serializerClass_3;
function $serializer_3() {
  if ($serializerClass_3 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_3 = this;
        var tmp0_serialDesc = new (InlineClassDescriptor())('com.lightningkite.services.data.Mass', this);
        tmp0_serialDesc.addElement_5pzumi_k$('kilograms', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_bch90s_k$(encoder, value) {
        var tmp0_inlineEncoder = encoder.encodeInline_wxp5pu_k$(this.descriptor_1);
        if (tmp0_inlineEncoder == null)
          null;
        else {
          tmp0_inlineEncoder.encodeDouble_n270q9_k$(_Mass___get_kilograms__impl__lr3pd5(value));
        }
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_bch90s_k$(encoder, value instanceof Mass() ? value.kilograms_1 : THROW_CCE());
      }
      deserialize_z6q192_k$(decoder) {
        return _Mass___init__impl__g55pzh(decoder.decodeInline_ux3vza_k$(this.descriptor_1).decodeDouble_ur8l0f_k$());
      }
      deserialize_sy6x50_k$(decoder) {
        return new (Mass())(this.deserialize_z6q192_k$(decoder));
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [DoubleSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_3 = $;
  }
  return $serializerClass_3;
}
var $serializer_instance_3;
function $serializer_getInstance_3() {
  if ($serializer_instance_3 === VOID)
    new ($serializer_3())();
  return $serializer_instance_3;
}
function Mass__hashCode_impl_ecd7ha($this) {
  return getNumberHashCode($this);
}
function Mass__equals_impl_k5bdom($this, other) {
  if (!(other instanceof Mass()))
    return false;
  var tmp0_other_with_cast = other.kilograms_1;
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
var MassClass;
function Mass() {
  if (MassClass === VOID) {
    class $ {
      constructor(kilograms) {
        this.kilograms_1 = kilograms;
      }
      compareTo_knoa1j_k$(other) {
        return Mass__compareTo_impl_3ilym9(this.kilograms_1, other);
      }
      compareTo_hpufkf_k$(other) {
        return Mass__compareTo_impl_3ilym9_0(this, other);
      }
      toString() {
        return Mass__toString_impl_yxkxoz(this.kilograms_1);
      }
      hashCode() {
        return Mass__hashCode_impl_ecd7ha(this.kilograms_1);
      }
      equals(other) {
        return Mass__equals_impl_k5bdom(this.kilograms_1, other);
      }
    }
    initMetadataForClass($, 'Mass', VOID, VOID, [Comparable()], VOID, VOID, {0: $serializer_getInstance_3});
    MassClass = $;
  }
  return MassClass;
}
function _Speed___init__impl__580hla(metersPerSecond) {
  return metersPerSecond;
}
function _Speed___get_metersPerSecond__impl__t1zksw($this) {
  return $this;
}
function Speed__compareTo_impl_wpf88c($this, other) {
  return compareTo(_Speed___get_metersPerSecond__impl__t1zksw($this), _Speed___get_metersPerSecond__impl__t1zksw(other));
}
function Speed__compareTo_impl_wpf88c_0($this, other) {
  return Speed__compareTo_impl_wpf88c($this.metersPerSecond_1, other instanceof Speed() ? other.metersPerSecond_1 : THROW_CCE());
}
function _Speed___get_feetPerSecond__impl__vx28ng($this) {
  return _Speed___get_metersPerSecond__impl__t1zksw($this) / 0.3048;
}
function _Speed___get_kilometersPerHour__impl__2ucvcx($this) {
  return _Speed___get_metersPerSecond__impl__t1zksw($this) / 0.2777777777777778;
}
function _Speed___get_milesPerHour__impl__yxl3t0($this) {
  return _Speed___get_metersPerSecond__impl__t1zksw($this) / 0.44704;
}
var CompanionClass_4;
function Companion_4() {
  if (CompanionClass_4 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_4();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_4 = $;
  }
  return CompanionClass_4;
}
var Companion_instance_4;
function Companion_getInstance_4() {
  return Companion_instance_4;
}
function Speed__toString_impl_c0l98a($this) {
  return '' + _Speed___get_metersPerSecond__impl__t1zksw($this) + ' m/s';
}
var $serializerClass_4;
function $serializer_4() {
  if ($serializerClass_4 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_4 = this;
        var tmp0_serialDesc = new (InlineClassDescriptor())('com.lightningkite.services.data.Speed', this);
        tmp0_serialDesc.addElement_5pzumi_k$('metersPerSecond', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_1c3ux7_k$(encoder, value) {
        var tmp0_inlineEncoder = encoder.encodeInline_wxp5pu_k$(this.descriptor_1);
        if (tmp0_inlineEncoder == null)
          null;
        else {
          tmp0_inlineEncoder.encodeDouble_n270q9_k$(_Speed___get_metersPerSecond__impl__t1zksw(value));
        }
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_1c3ux7_k$(encoder, value instanceof Speed() ? value.metersPerSecond_1 : THROW_CCE());
      }
      deserialize_p867fz_k$(decoder) {
        return _Speed___init__impl__580hla(decoder.decodeInline_ux3vza_k$(this.descriptor_1).decodeDouble_ur8l0f_k$());
      }
      deserialize_sy6x50_k$(decoder) {
        return new (Speed())(this.deserialize_p867fz_k$(decoder));
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [DoubleSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_4 = $;
  }
  return $serializerClass_4;
}
var $serializer_instance_4;
function $serializer_getInstance_4() {
  if ($serializer_instance_4 === VOID)
    new ($serializer_4())();
  return $serializer_instance_4;
}
function Speed__hashCode_impl_9qknkl($this) {
  return getNumberHashCode($this);
}
function Speed__equals_impl_ahn41l($this, other) {
  if (!(other instanceof Speed()))
    return false;
  var tmp0_other_with_cast = other.metersPerSecond_1;
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
var SpeedClass;
function Speed() {
  if (SpeedClass === VOID) {
    class $ {
      constructor(metersPerSecond) {
        this.metersPerSecond_1 = metersPerSecond;
      }
      compareTo_289sky_k$(other) {
        return Speed__compareTo_impl_wpf88c(this.metersPerSecond_1, other);
      }
      compareTo_hpufkf_k$(other) {
        return Speed__compareTo_impl_wpf88c_0(this, other);
      }
      toString() {
        return Speed__toString_impl_c0l98a(this.metersPerSecond_1);
      }
      hashCode() {
        return Speed__hashCode_impl_9qknkl(this.metersPerSecond_1);
      }
      equals(other) {
        return Speed__equals_impl_ahn41l(this.metersPerSecond_1, other);
      }
    }
    initMetadataForClass($, 'Speed', VOID, VOID, [Comparable()], VOID, VOID, {0: $serializer_getInstance_4});
    SpeedClass = $;
  }
  return SpeedClass;
}
function _Acceleration___init__impl__lpurpb(metersPerSecondPerSecond) {
  return metersPerSecondPerSecond;
}
function _Acceleration___get_metersPerSecondPerSecond__impl__3zde26($this) {
  return $this;
}
function Acceleration__compareTo_impl_v9l3hv($this, other) {
  return compareTo(_Acceleration___get_metersPerSecondPerSecond__impl__3zde26($this), _Acceleration___get_metersPerSecondPerSecond__impl__3zde26(other));
}
function Acceleration__compareTo_impl_v9l3hv_0($this, other) {
  return Acceleration__compareTo_impl_v9l3hv($this.metersPerSecondPerSecond_1, other instanceof Acceleration() ? other.metersPerSecondPerSecond_1 : THROW_CCE());
}
function _Acceleration___get_feetPerSecondPerSecond__impl__3tkghi($this) {
  return _Acceleration___get_metersPerSecondPerSecond__impl__3zde26($this) / 0.3048;
}
function _Acceleration___get_kilometersPerHourPerSecond__impl__toxtnn($this) {
  return _Acceleration___get_metersPerSecondPerSecond__impl__3zde26($this) / 0.2777777777777778;
}
function _Acceleration___get_milesPerHourPerSecond__impl__umq308($this) {
  return _Acceleration___get_metersPerSecondPerSecond__impl__3zde26($this) / 0.44704;
}
var CompanionClass_5;
function Companion_5() {
  if (CompanionClass_5 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_5();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_5 = $;
  }
  return CompanionClass_5;
}
var Companion_instance_5;
function Companion_getInstance_5() {
  return Companion_instance_5;
}
function Acceleration__toString_impl_8k4hwf($this) {
  return '' + _Acceleration___get_metersPerSecondPerSecond__impl__3zde26($this) + ' m/s\xB2';
}
var $serializerClass_5;
function $serializer_5() {
  if ($serializerClass_5 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_5 = this;
        var tmp0_serialDesc = new (InlineClassDescriptor())('com.lightningkite.services.data.Acceleration', this);
        tmp0_serialDesc.addElement_5pzumi_k$('metersPerSecondPerSecond', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_40u9ko_k$(encoder, value) {
        var tmp0_inlineEncoder = encoder.encodeInline_wxp5pu_k$(this.descriptor_1);
        if (tmp0_inlineEncoder == null)
          null;
        else {
          tmp0_inlineEncoder.encodeDouble_n270q9_k$(_Acceleration___get_metersPerSecondPerSecond__impl__3zde26(value));
        }
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_40u9ko_k$(encoder, value instanceof Acceleration() ? value.metersPerSecondPerSecond_1 : THROW_CCE());
      }
      deserialize_vj0abu_k$(decoder) {
        return _Acceleration___init__impl__lpurpb(decoder.decodeInline_ux3vza_k$(this.descriptor_1).decodeDouble_ur8l0f_k$());
      }
      deserialize_sy6x50_k$(decoder) {
        return new (Acceleration())(this.deserialize_vj0abu_k$(decoder));
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [DoubleSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_5 = $;
  }
  return $serializerClass_5;
}
var $serializer_instance_5;
function $serializer_getInstance_5() {
  if ($serializer_instance_5 === VOID)
    new ($serializer_5())();
  return $serializer_instance_5;
}
function Acceleration__hashCode_impl_ubaepa($this) {
  return getNumberHashCode($this);
}
function Acceleration__equals_impl_evel1u($this, other) {
  if (!(other instanceof Acceleration()))
    return false;
  var tmp0_other_with_cast = other.metersPerSecondPerSecond_1;
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
var AccelerationClass;
function Acceleration() {
  if (AccelerationClass === VOID) {
    class $ {
      constructor(metersPerSecondPerSecond) {
        this.metersPerSecondPerSecond_1 = metersPerSecondPerSecond;
      }
      compareTo_2j3r5h_k$(other) {
        return Acceleration__compareTo_impl_v9l3hv(this.metersPerSecondPerSecond_1, other);
      }
      compareTo_hpufkf_k$(other) {
        return Acceleration__compareTo_impl_v9l3hv_0(this, other);
      }
      toString() {
        return Acceleration__toString_impl_8k4hwf(this.metersPerSecondPerSecond_1);
      }
      hashCode() {
        return Acceleration__hashCode_impl_ubaepa(this.metersPerSecondPerSecond_1);
      }
      equals(other) {
        return Acceleration__equals_impl_evel1u(this.metersPerSecondPerSecond_1, other);
      }
    }
    initMetadataForClass($, 'Acceleration', VOID, VOID, [Comparable()], VOID, VOID, {0: $serializer_getInstance_5});
    AccelerationClass = $;
  }
  return AccelerationClass;
}
function _Pressure___init__impl__4rek04(pascals) {
  return pascals;
}
function _Pressure___get_pascals__impl__m59t3u($this) {
  return $this;
}
function Pressure__compareTo_impl_b1ld0u($this, other) {
  return compareTo(_Pressure___get_pascals__impl__m59t3u($this), _Pressure___get_pascals__impl__m59t3u(other));
}
function Pressure__compareTo_impl_b1ld0u_0($this, other) {
  return Pressure__compareTo_impl_b1ld0u($this.pascals_1, other instanceof Pressure() ? other.pascals_1 : THROW_CCE());
}
function _Pressure___get_atmospheres__impl__m90i7k($this) {
  return _Pressure___get_pascals__impl__m59t3u($this) / 101325.0;
}
function _Pressure___get_bars__impl__4r7a77($this) {
  return _Pressure___get_pascals__impl__m59t3u($this) / 100000.0;
}
function _Pressure___get_millibars__impl__we5tn8($this) {
  return _Pressure___get_pascals__impl__m59t3u($this) / 100.0;
}
function _Pressure___get_psi__impl__877eh1($this) {
  return _Pressure___get_pascals__impl__m59t3u($this) / 6894.757889515778;
}
var CompanionClass_6;
function Companion_6() {
  if (CompanionClass_6 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_6();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_6 = $;
  }
  return CompanionClass_6;
}
var Companion_instance_6;
function Companion_getInstance_6() {
  return Companion_instance_6;
}
function Pressure__toString_impl_a74mx0($this) {
  return '' + _Pressure___get_pascals__impl__m59t3u($this) + ' Pa';
}
var $serializerClass_6;
function $serializer_6() {
  if ($serializerClass_6 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_6 = this;
        var tmp0_serialDesc = new (InlineClassDescriptor())('com.lightningkite.services.data.Pressure', this);
        tmp0_serialDesc.addElement_5pzumi_k$('pascals', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_dw9cil_k$(encoder, value) {
        var tmp0_inlineEncoder = encoder.encodeInline_wxp5pu_k$(this.descriptor_1);
        if (tmp0_inlineEncoder == null)
          null;
        else {
          tmp0_inlineEncoder.encodeDouble_n270q9_k$(_Pressure___get_pascals__impl__m59t3u(value));
        }
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_dw9cil_k$(encoder, value instanceof Pressure() ? value.pascals_1 : THROW_CCE());
      }
      deserialize_grixs5_k$(decoder) {
        return _Pressure___init__impl__4rek04(decoder.decodeInline_ux3vza_k$(this.descriptor_1).decodeDouble_ur8l0f_k$());
      }
      deserialize_sy6x50_k$(decoder) {
        return new (Pressure())(this.deserialize_grixs5_k$(decoder));
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [DoubleSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_6 = $;
  }
  return $serializerClass_6;
}
var $serializer_instance_6;
function $serializer_getInstance_6() {
  if ($serializer_instance_6 === VOID)
    new ($serializer_6())();
  return $serializer_instance_6;
}
function Pressure__hashCode_impl_vyajpv($this) {
  return getNumberHashCode($this);
}
function Pressure__equals_impl_9vxi6h($this, other) {
  if (!(other instanceof Pressure()))
    return false;
  var tmp0_other_with_cast = other.pascals_1;
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
var PressureClass;
function Pressure() {
  if (PressureClass === VOID) {
    class $ {
      constructor(pascals) {
        this.pascals_1 = pascals;
      }
      compareTo_q5dsx2_k$(other) {
        return Pressure__compareTo_impl_b1ld0u(this.pascals_1, other);
      }
      compareTo_hpufkf_k$(other) {
        return Pressure__compareTo_impl_b1ld0u_0(this, other);
      }
      toString() {
        return Pressure__toString_impl_a74mx0(this.pascals_1);
      }
      hashCode() {
        return Pressure__hashCode_impl_vyajpv(this.pascals_1);
      }
      equals(other) {
        return Pressure__equals_impl_9vxi6h(this.pascals_1, other);
      }
    }
    initMetadataForClass($, 'Pressure', VOID, VOID, [Comparable()], VOID, VOID, {0: $serializer_getInstance_6});
    PressureClass = $;
  }
  return PressureClass;
}
function _Energy___init__impl__paow1l(joules) {
  return joules;
}
function _Energy___get_joules__impl__q784q($this) {
  return $this;
}
function Energy__compareTo_impl_gcljvv($this, other) {
  return compareTo(_Energy___get_joules__impl__q784q($this), _Energy___get_joules__impl__q784q(other));
}
function Energy__compareTo_impl_gcljvv_0($this, other) {
  return Energy__compareTo_impl_gcljvv($this.joules_1, other instanceof Energy() ? other.joules_1 : THROW_CCE());
}
var CompanionClass_7;
function Companion_7() {
  if (CompanionClass_7 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_7();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_7 = $;
  }
  return CompanionClass_7;
}
var Companion_instance_7;
function Companion_getInstance_7() {
  return Companion_instance_7;
}
function Energy__toString_impl_jf1pax($this) {
  return '' + _Energy___get_joules__impl__q784q($this) + ' J';
}
var $serializerClass_7;
function $serializer_7() {
  if ($serializerClass_7 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_7 = this;
        var tmp0_serialDesc = new (InlineClassDescriptor())('com.lightningkite.services.data.Energy', this);
        tmp0_serialDesc.addElement_5pzumi_k$('joules', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_9uvxc0_k$(encoder, value) {
        var tmp0_inlineEncoder = encoder.encodeInline_wxp5pu_k$(this.descriptor_1);
        if (tmp0_inlineEncoder == null)
          null;
        else {
          tmp0_inlineEncoder.encodeDouble_n270q9_k$(_Energy___get_joules__impl__q784q(value));
        }
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_9uvxc0_k$(encoder, value instanceof Energy() ? value.joules_1 : THROW_CCE());
      }
      deserialize_7cttxe_k$(decoder) {
        return _Energy___init__impl__paow1l(decoder.decodeInline_ux3vza_k$(this.descriptor_1).decodeDouble_ur8l0f_k$());
      }
      deserialize_sy6x50_k$(decoder) {
        return new (Energy())(this.deserialize_7cttxe_k$(decoder));
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [DoubleSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_7 = $;
  }
  return $serializerClass_7;
}
var $serializer_instance_7;
function $serializer_getInstance_7() {
  if ($serializer_instance_7 === VOID)
    new ($serializer_7())();
  return $serializer_instance_7;
}
function Energy__hashCode_impl_2c47hy($this) {
  return getNumberHashCode($this);
}
function Energy__equals_impl_gsi3fq($this, other) {
  if (!(other instanceof Energy()))
    return false;
  var tmp0_other_with_cast = other.joules_1;
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
var EnergyClass;
function Energy() {
  if (EnergyClass === VOID) {
    class $ {
      constructor(joules) {
        this.joules_1 = joules;
      }
      compareTo_szf799_k$(other) {
        return Energy__compareTo_impl_gcljvv(this.joules_1, other);
      }
      compareTo_hpufkf_k$(other) {
        return Energy__compareTo_impl_gcljvv_0(this, other);
      }
      toString() {
        return Energy__toString_impl_jf1pax(this.joules_1);
      }
      hashCode() {
        return Energy__hashCode_impl_2c47hy(this.joules_1);
      }
      equals(other) {
        return Energy__equals_impl_gsi3fq(this.joules_1, other);
      }
    }
    initMetadataForClass($, 'Energy', VOID, VOID, [Comparable()], VOID, VOID, {0: $serializer_getInstance_7});
    EnergyClass = $;
  }
  return EnergyClass;
}
function _Force___init__impl__w7900e(newtons) {
  return newtons;
}
function _Force___get_newtons__impl__qua8gd($this) {
  return $this;
}
function Force__compareTo_impl_fidpvc($this, other) {
  return compareTo(_Force___get_newtons__impl__qua8gd($this), _Force___get_newtons__impl__qua8gd(other));
}
function Force__compareTo_impl_fidpvc_0($this, other) {
  return Force__compareTo_impl_fidpvc($this.newtons_1, other instanceof Force() ? other.newtons_1 : THROW_CCE());
}
function _Force___get_poundForce__impl__ne6ai4($this) {
  return _Force___get_newtons__impl__qua8gd($this) / 4.448222;
}
var CompanionClass_8;
function Companion_8() {
  if (CompanionClass_8 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_8();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_8 = $;
  }
  return CompanionClass_8;
}
var Companion_instance_8;
function Companion_getInstance_8() {
  return Companion_instance_8;
}
function Force__toString_impl_bms0tm($this) {
  return '' + _Force___get_newtons__impl__qua8gd($this) + ' N';
}
var $serializerClass_8;
function $serializer_8() {
  if ($serializerClass_8 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_8 = this;
        var tmp0_serialDesc = new (InlineClassDescriptor())('com.lightningkite.services.data.Force', this);
        tmp0_serialDesc.addElement_5pzumi_k$('newtons', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_klpevl_k$(encoder, value) {
        var tmp0_inlineEncoder = encoder.encodeInline_wxp5pu_k$(this.descriptor_1);
        if (tmp0_inlineEncoder == null)
          null;
        else {
          tmp0_inlineEncoder.encodeDouble_n270q9_k$(_Force___get_newtons__impl__qua8gd(value));
        }
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_klpevl_k$(encoder, value instanceof Force() ? value.newtons_1 : THROW_CCE());
      }
      deserialize_pfbwjv_k$(decoder) {
        return _Force___init__impl__w7900e(decoder.decodeInline_ux3vza_k$(this.descriptor_1).decodeDouble_ur8l0f_k$());
      }
      deserialize_sy6x50_k$(decoder) {
        return new (Force())(this.deserialize_pfbwjv_k$(decoder));
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [DoubleSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_8 = $;
  }
  return $serializerClass_8;
}
var $serializer_instance_8;
function $serializer_getInstance_8() {
  if ($serializer_instance_8 === VOID)
    new ($serializer_8())();
  return $serializer_instance_8;
}
function Force__hashCode_impl_xdxxmh($this) {
  return getNumberHashCode($this);
}
function Force__equals_impl_di9dib($this, other) {
  if (!(other instanceof Force()))
    return false;
  var tmp0_other_with_cast = other.newtons_1;
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
var ForceClass;
function Force() {
  if (ForceClass === VOID) {
    class $ {
      constructor(newtons) {
        this.newtons_1 = newtons;
      }
      compareTo_bns5am_k$(other) {
        return Force__compareTo_impl_fidpvc(this.newtons_1, other);
      }
      compareTo_hpufkf_k$(other) {
        return Force__compareTo_impl_fidpvc_0(this, other);
      }
      toString() {
        return Force__toString_impl_bms0tm(this.newtons_1);
      }
      hashCode() {
        return Force__hashCode_impl_xdxxmh(this.newtons_1);
      }
      equals(other) {
        return Force__equals_impl_di9dib(this.newtons_1, other);
      }
    }
    initMetadataForClass($, 'Force', VOID, VOID, [Comparable()], VOID, VOID, {0: $serializer_getInstance_8});
    ForceClass = $;
  }
  return ForceClass;
}
function _Power___init__impl__y6lnpo(watts) {
  return watts;
}
function _Power___get_watts__impl__8v3onk($this) {
  return $this;
}
function Power__compareTo_impl_pinqky($this, other) {
  return compareTo(_Power___get_watts__impl__8v3onk($this), _Power___get_watts__impl__8v3onk(other));
}
function Power__compareTo_impl_pinqky_0($this, other) {
  return Power__compareTo_impl_pinqky($this.watts_1, other instanceof Power() ? other.watts_1 : THROW_CCE());
}
function _Power___get_kilowatts__impl__xnqgmn($this) {
  return _Power___get_watts__impl__8v3onk($this) / 1000.0;
}
var CompanionClass_9;
function Companion_9() {
  if (CompanionClass_9 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_9();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_9 = $;
  }
  return CompanionClass_9;
}
var Companion_instance_9;
function Companion_getInstance_9() {
  return Companion_instance_9;
}
function Power__toString_impl_dln6o4($this) {
  return '' + _Power___get_watts__impl__8v3onk($this) + ' W';
}
var $serializerClass_9;
function $serializer_9() {
  if ($serializerClass_9 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_9 = this;
        var tmp0_serialDesc = new (InlineClassDescriptor())('com.lightningkite.services.data.Power', this);
        tmp0_serialDesc.addElement_5pzumi_k$('watts', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_epg761_k$(encoder, value) {
        var tmp0_inlineEncoder = encoder.encodeInline_wxp5pu_k$(this.descriptor_1);
        if (tmp0_inlineEncoder == null)
          null;
        else {
          tmp0_inlineEncoder.encodeDouble_n270q9_k$(_Power___get_watts__impl__8v3onk(value));
        }
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_epg761_k$(encoder, value instanceof Power() ? value.watts_1 : THROW_CCE());
      }
      deserialize_p9tuup_k$(decoder) {
        return _Power___init__impl__y6lnpo(decoder.decodeInline_ux3vza_k$(this.descriptor_1).decodeDouble_ur8l0f_k$());
      }
      deserialize_sy6x50_k$(decoder) {
        return new (Power())(this.deserialize_p9tuup_k$(decoder));
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [DoubleSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_9 = $;
  }
  return $serializerClass_9;
}
var $serializer_instance_9;
function $serializer_getInstance_9() {
  if ($serializer_instance_9 === VOID)
    new ($serializer_9())();
  return $serializer_instance_9;
}
function Power__hashCode_impl_zct3gz($this) {
  return getNumberHashCode($this);
}
function Power__equals_impl_vorjd5($this, other) {
  if (!(other instanceof Power()))
    return false;
  var tmp0_other_with_cast = other.watts_1;
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
var PowerClass;
function Power() {
  if (PowerClass === VOID) {
    class $ {
      constructor(watts) {
        this.watts_1 = watts;
      }
      compareTo_ulip70_k$(other) {
        return Power__compareTo_impl_pinqky(this.watts_1, other);
      }
      compareTo_hpufkf_k$(other) {
        return Power__compareTo_impl_pinqky_0(this, other);
      }
      toString() {
        return Power__toString_impl_dln6o4(this.watts_1);
      }
      hashCode() {
        return Power__hashCode_impl_zct3gz(this.watts_1);
      }
      equals(other) {
        return Power__equals_impl_vorjd5(this.watts_1, other);
      }
    }
    initMetadataForClass($, 'Power', VOID, VOID, [Comparable()], VOID, VOID, {0: $serializer_getInstance_9});
    PowerClass = $;
  }
  return PowerClass;
}
function _Temperature___init__impl__i36a2t(celsius) {
  return celsius;
}
function _Temperature___get_celsius__impl__lhbsrw($this) {
  return $this;
}
function Temperature__compareTo_impl_hlr075($this, other) {
  return compareTo(_Temperature___get_celsius__impl__lhbsrw($this), _Temperature___get_celsius__impl__lhbsrw(other));
}
function Temperature__compareTo_impl_hlr075_0($this, other) {
  return Temperature__compareTo_impl_hlr075($this.celsius_1, other instanceof Temperature() ? other.celsius_1 : THROW_CCE());
}
function _Temperature___get_fahrenheit__impl__xao1tu($this) {
  return _Temperature___get_celsius__impl__lhbsrw($this) * 9 / 5 + 32;
}
function _Temperature___get_kelvin__impl__us25d7($this) {
  return _Temperature___get_celsius__impl__lhbsrw($this) + 273.15;
}
var CompanionClass_10;
function Companion_10() {
  if (CompanionClass_10 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_10();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_10 = $;
  }
  return CompanionClass_10;
}
var Companion_instance_10;
function Companion_getInstance_10() {
  return Companion_instance_10;
}
function Temperature__toString_impl_yh7zyr($this) {
  return '' + _Temperature___get_celsius__impl__lhbsrw($this) + '\xB0C';
}
var $serializerClass_10;
function $serializer_10() {
  if ($serializerClass_10 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_10 = this;
        var tmp0_serialDesc = new (InlineClassDescriptor())('com.lightningkite.services.data.Temperature', this);
        tmp0_serialDesc.addElement_5pzumi_k$('celsius', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_5y4rvs_k$(encoder, value) {
        var tmp0_inlineEncoder = encoder.encodeInline_wxp5pu_k$(this.descriptor_1);
        if (tmp0_inlineEncoder == null)
          null;
        else {
          tmp0_inlineEncoder.encodeDouble_n270q9_k$(_Temperature___get_celsius__impl__lhbsrw(value));
        }
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_5y4rvs_k$(encoder, value instanceof Temperature() ? value.celsius_1 : THROW_CCE());
      }
      deserialize_dm041q_k$(decoder) {
        return _Temperature___init__impl__i36a2t(decoder.decodeInline_ux3vza_k$(this.descriptor_1).decodeDouble_ur8l0f_k$());
      }
      deserialize_sy6x50_k$(decoder) {
        return new (Temperature())(this.deserialize_dm041q_k$(decoder));
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [DoubleSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_10 = $;
  }
  return $serializerClass_10;
}
var $serializer_instance_10;
function $serializer_getInstance_10() {
  if ($serializer_instance_10 === VOID)
    new ($serializer_10())();
  return $serializer_instance_10;
}
function Temperature__hashCode_impl_esq57i($this) {
  return getNumberHashCode($this);
}
function Temperature__equals_impl_91r1ru($this, other) {
  if (!(other instanceof Temperature()))
    return false;
  var tmp0_other_with_cast = other.celsius_1;
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
var TemperatureClass;
function Temperature() {
  if (TemperatureClass === VOID) {
    class $ {
      constructor(celsius) {
        this.celsius_1 = celsius;
      }
      compareTo_nd9o4b_k$(other) {
        return Temperature__compareTo_impl_hlr075(this.celsius_1, other);
      }
      compareTo_hpufkf_k$(other) {
        return Temperature__compareTo_impl_hlr075_0(this, other);
      }
      toString() {
        return Temperature__toString_impl_yh7zyr(this.celsius_1);
      }
      hashCode() {
        return Temperature__hashCode_impl_esq57i(this.celsius_1);
      }
      equals(other) {
        return Temperature__equals_impl_91r1ru(this.celsius_1, other);
      }
    }
    initMetadataForClass($, 'Temperature', VOID, VOID, [Comparable()], VOID, VOID, {0: $serializer_getInstance_10});
    TemperatureClass = $;
  }
  return TemperatureClass;
}
function _RelativeTemperature___init__impl__s2670v(celsius) {
  return celsius;
}
function _RelativeTemperature___get_celsius__impl__beofh4($this) {
  return $this;
}
function RelativeTemperature__compareTo_impl_e2gjaj($this, other) {
  return compareTo(_RelativeTemperature___get_celsius__impl__beofh4($this), _Temperature___get_celsius__impl__lhbsrw(other));
}
function RelativeTemperature__compareTo_impl_e2gjaj_0($this, other) {
  return RelativeTemperature__compareTo_impl_e2gjaj($this.celsius_1, other instanceof Temperature() ? other.celsius_1 : THROW_CCE());
}
function _RelativeTemperature___get_fahrenheit__impl__tymu26($this) {
  return _RelativeTemperature___get_celsius__impl__beofh4($this) * 9 / 5;
}
function _RelativeTemperature___get_kelvin__impl__wquk3j($this) {
  return _RelativeTemperature___get_celsius__impl__beofh4($this);
}
var CompanionClass_11;
function Companion_11() {
  if (CompanionClass_11 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_11();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_11 = $;
  }
  return CompanionClass_11;
}
var Companion_instance_11;
function Companion_getInstance_11() {
  return Companion_instance_11;
}
function RelativeTemperature__toString_impl_14ouzr($this) {
  return '' + _RelativeTemperature___get_celsius__impl__beofh4($this) + '\xB0C';
}
var $serializerClass_11;
function $serializer_11() {
  if ($serializerClass_11 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_11 = this;
        var tmp0_serialDesc = new (InlineClassDescriptor())('com.lightningkite.services.data.RelativeTemperature', this);
        tmp0_serialDesc.addElement_5pzumi_k$('celsius', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_s3lfxo_k$(encoder, value) {
        var tmp0_inlineEncoder = encoder.encodeInline_wxp5pu_k$(this.descriptor_1);
        if (tmp0_inlineEncoder == null)
          null;
        else {
          tmp0_inlineEncoder.encodeDouble_n270q9_k$(_RelativeTemperature___get_celsius__impl__beofh4(value));
        }
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_s3lfxo_k$(encoder, value instanceof RelativeTemperature() ? value.celsius_1 : THROW_CCE());
      }
      deserialize_hfoj6a_k$(decoder) {
        return _RelativeTemperature___init__impl__s2670v(decoder.decodeInline_ux3vza_k$(this.descriptor_1).decodeDouble_ur8l0f_k$());
      }
      deserialize_sy6x50_k$(decoder) {
        return new (RelativeTemperature())(this.deserialize_hfoj6a_k$(decoder));
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [DoubleSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_11 = $;
  }
  return $serializerClass_11;
}
var $serializer_instance_11;
function $serializer_getInstance_11() {
  if ($serializer_instance_11 === VOID)
    new ($serializer_11())();
  return $serializer_instance_11;
}
function RelativeTemperature__hashCode_impl_mvursm($this) {
  return getNumberHashCode($this);
}
function RelativeTemperature__equals_impl_ugknyy($this, other) {
  if (!(other instanceof RelativeTemperature()))
    return false;
  var tmp0_other_with_cast = other.celsius_1;
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
var RelativeTemperatureClass;
function RelativeTemperature() {
  if (RelativeTemperatureClass === VOID) {
    class $ {
      constructor(celsius) {
        this.celsius_1 = celsius;
      }
      compareTo_nd9o4b_k$(other) {
        return RelativeTemperature__compareTo_impl_e2gjaj(this.celsius_1, other);
      }
      compareTo_hpufkf_k$(other) {
        return RelativeTemperature__compareTo_impl_e2gjaj_0(this, other);
      }
      toString() {
        return RelativeTemperature__toString_impl_14ouzr(this.celsius_1);
      }
      hashCode() {
        return RelativeTemperature__hashCode_impl_mvursm(this.celsius_1);
      }
      equals(other) {
        return RelativeTemperature__equals_impl_ugknyy(this.celsius_1, other);
      }
    }
    initMetadataForClass($, 'RelativeTemperature', VOID, VOID, [Comparable()], VOID, VOID, {0: $serializer_getInstance_11});
    RelativeTemperatureClass = $;
  }
  return RelativeTemperatureClass;
}
//region block: init
Companion_instance = new (Companion())();
Companion_instance_0 = new (Companion_0())();
Companion_instance_1 = new (Companion_1())();
Companion_instance_2 = new (Companion_2())();
Companion_instance_3 = new (Companion_3())();
Companion_instance_4 = new (Companion_4())();
Companion_instance_5 = new (Companion_5())();
Companion_instance_6 = new (Companion_6())();
Companion_instance_7 = new (Companion_7())();
Companion_instance_8 = new (Companion_8())();
Companion_instance_9 = new (Companion_9())();
Companion_instance_10 = new (Companion_10())();
Companion_instance_11 = new (Companion_11())();
//endregion
//region block: exports
export {
  Acceleration as Acceleration2sg6kr91atni2,
  Area as Area3pv4op213wjp3,
  DataSize as DataSize1huql7djnl3ch,
  Energy as Energy165sfuoiv695w,
  Force as Force2u0di6c6847v4,
  Length as Lengthtca6d2z3zjle,
  Mass as Massc7d9yuefyj4d,
  Power as Power2nl309hjq9mej,
  Pressure as Pressure2waumxspf1dhw,
  RelativeTemperature as RelativeTemperature2jxfnlsp9qlrv,
  Speed as Speed3hiscdw6s9yl6,
  Temperature as Temperature1qifhfdfpkqkr,
  Volume as Volumegj5eonccqlgm,
  _Acceleration___init__impl__lpurpb as _Acceleration___init__impl__lpurpblc5vcql0b289,
  _Acceleration___get_feetPerSecondPerSecond__impl__3tkghi as _Acceleration___get_feetPerSecondPerSecond__impl__3tkghi1mb0ofbwrcml6,
  _Acceleration___get_kilometersPerHourPerSecond__impl__toxtnn as _Acceleration___get_kilometersPerHourPerSecond__impl__toxtnn3s020ht51hgv7,
  _Acceleration___get_metersPerSecondPerSecond__impl__3zde26 as _Acceleration___get_metersPerSecondPerSecond__impl__3zde26ph2lxv53gusg,
  _Acceleration___get_milesPerHourPerSecond__impl__umq308 as _Acceleration___get_milesPerHourPerSecond__impl__umq308epcbiadbsmt0,
  _Area___init__impl__ijsx70 as _Area___init__impl__ijsx701jgfgrev4lwyu,
  _Area___get_acres__impl__gakf2d as _Area___get_acres__impl__gakf2d1zdhpqeurygsy,
  _Area___get_hectare__impl__ftwe8j as _Area___get_hectare__impl__ftwe8j2j3yb5rotpabi,
  _Area___get_squareCentimeters__impl__t9odvv as _Area___get_squareCentimeters__impl__t9odvv2wxr3i0jquf45,
  _Area___get_squareKilometers__impl__3iiltv as _Area___get_squareKilometers__impl__3iiltvxa75zm5w6d0y,
  _Area___get_squareMeters__impl__tdkp4u as _Area___get_squareMeters__impl__tdkp4u15ncadegyagje,
  _Area___get_squareMillimeters__impl__fkxnwh as _Area___get_squareMillimeters__impl__fkxnwh1hx6rputs3h3k,
  _DataSize___init__impl__iz9cfq as _DataSize___init__impl__iz9cfq2nx4f2ygs4tzd,
  _DataSize___get_bytes__impl__nlgkc0 as _DataSize___get_bytes__impl__nlgkc01z4tmgjphplqt,
  _DataSize___get_decimalGigabytes__impl__q3ocl7 as _DataSize___get_decimalGigabytes__impl__q3ocl73i5vj3rtw7nsp,
  _DataSize___get_decimalKilobytes__impl__rjupzq as _DataSize___get_decimalKilobytes__impl__rjupzq2kufobf681jxl,
  _DataSize___get_decimalMegabytes__impl__yffmh1 as _DataSize___get_decimalMegabytes__impl__yffmh1604xokytgy7k,
  _DataSize___get_decimalTerabytes__impl__rl89rd as _DataSize___get_decimalTerabytes__impl__rl89rd2lw24pwer94jn,
  _DataSize___get_gibibytes__impl__nz4fl3 as _DataSize___get_gibibytes__impl__nz4fl310l3crev7a8l4,
  _DataSize___get_kibibytes__impl__da5jmd as _DataSize___get_kibibytes__impl__da5jmd1ypxn0qeaxzns,
  _DataSize___get_mebibytes__impl__wavpgx as _DataSize___get_mebibytes__impl__wavpgx2uvshm4k8ffs4,
  _DataSize___get_tebibytes__impl__kdhac8 as _DataSize___get_tebibytes__impl__kdhac8mxvsbapsinb7,
  _Energy___init__impl__paow1l as _Energy___init__impl__paow1l1qd7fp5jh2hhe,
  _Energy___get_joules__impl__q784q as _Energy___get_joules__impl__q784q2ctvajuqmhi3f,
  _Force___init__impl__w7900e as _Force___init__impl__w7900e3gdp3n8t11y81,
  _Force___get_newtons__impl__qua8gd as _Force___get_newtons__impl__qua8gd1rlfdtz7of3hw,
  _Force___get_poundForce__impl__ne6ai4 as _Force___get_poundForce__impl__ne6ai41hzjkpddraa12,
  _Length___init__impl__mrryhn as _Length___init__impl__mrryhneua5rtcihrff,
  _Length___get_centimeters__impl__ltzset as _Length___get_centimeters__impl__ltzset3oo1ambi7xz9c,
  _Length___get_feet__impl__kw6lw0 as _Length___get_feet__impl__kw6lw03vnqmywlcgiiu,
  _Length___get_inches__impl__de09ru as _Length___get_inches__impl__de09ru2w874nuco27g7,
  _Length___get_kilometers__impl__syiikt as _Length___get_kilometers__impl__syiikt2ggk89idxg8kf,
  _Length___get_meters__impl__co03t8 as _Length___get_meters__impl__co03t81dk8pddg1dukz,
  _Length___get_micrometer__impl__xab82h as _Length___get_micrometer__impl__xab82h135ct2wvsoz7s,
  _Length___get_miles__impl__iwi6te as _Length___get_miles__impl__iwi6teo2f2mow8y1og,
  _Length___get_millimeter__impl__i75bku as _Length___get_millimeter__impl__i75bku4vgae6s0i7im,
  _Length___get_nanometer__impl__86nsy3 as _Length___get_nanometer__impl__86nsy3iwgcd0xbqear,
  _Length___get_yards__impl__8j9pnr as _Length___get_yards__impl__8j9pnr3vhkth696eqf4,
  _Mass___init__impl__g55pzh as _Mass___init__impl__g55pzh1l06mgzajhizq,
  _Mass___get_grams__impl__rxyb9m as _Mass___get_grams__impl__rxyb9m3dsn4n9ablui,
  _Mass___get_kilograms__impl__lr3pd5 as _Mass___get_kilograms__impl__lr3pd5zivx4ihumesy,
  _Mass___get_milligrams__impl__s8wiar as _Mass___get_milligrams__impl__s8wiarnsd8uz6gmo3k,
  _Mass___get_pounds__impl__r7075n as _Mass___get_pounds__impl__r7075nulkd9gbvtgb,
  _Mass___get_tonnes__impl__aj2kxp as _Mass___get_tonnes__impl__aj2kxp3q9zh45pyc76m,
  _Mass___get_tons__impl__so9xvw as _Mass___get_tons__impl__so9xvw2ic7hyiso53t8,
  _Mass___get_weightOunces__impl__w4i8hh as _Mass___get_weightOunces__impl__w4i8hh1ic2p2iyma7r2,
  _Power___init__impl__y6lnpo as _Power___init__impl__y6lnpo30h3udcwtlqs7,
  _Power___get_kilowatts__impl__xnqgmn as _Power___get_kilowatts__impl__xnqgmnibp5tyz5sz9v,
  _Power___get_watts__impl__8v3onk as _Power___get_watts__impl__8v3onk1meh6yqi1q5xy,
  _Pressure___init__impl__4rek04 as _Pressure___init__impl__4rek047cbbbitchry8,
  _Pressure___get_atmospheres__impl__m90i7k as _Pressure___get_atmospheres__impl__m90i7k1wejul9q6e094,
  _Pressure___get_bars__impl__4r7a77 as _Pressure___get_bars__impl__4r7a771n9cfmb5tfau4,
  _Pressure___get_millibars__impl__we5tn8 as _Pressure___get_millibars__impl__we5tn88juiqodu1axm,
  _Pressure___get_pascals__impl__m59t3u as _Pressure___get_pascals__impl__m59t3ulrqcl9cqtk1z,
  _Pressure___get_psi__impl__877eh1 as _Pressure___get_psi__impl__877eh1bs5b88nrctez,
  _RelativeTemperature___init__impl__s2670v as _RelativeTemperature___init__impl__s2670v3t3o6cir0mx61,
  _RelativeTemperature___get_celsius__impl__beofh4 as _RelativeTemperature___get_celsius__impl__beofh4vi4rzxz7zzby,
  _RelativeTemperature___get_fahrenheit__impl__tymu26 as _RelativeTemperature___get_fahrenheit__impl__tymu2628ni3al6h3kd0,
  _RelativeTemperature___get_kelvin__impl__wquk3j as _RelativeTemperature___get_kelvin__impl__wquk3j1tjxqc3ijucsn,
  _Speed___init__impl__580hla as _Speed___init__impl__580hla120ske4lxoqd4,
  _Speed___get_feetPerSecond__impl__vx28ng as _Speed___get_feetPerSecond__impl__vx28ng12jmil5je79ti,
  _Speed___get_kilometersPerHour__impl__2ucvcx as _Speed___get_kilometersPerHour__impl__2ucvcx2889oonv915f8,
  _Speed___get_metersPerSecond__impl__t1zksw as _Speed___get_metersPerSecond__impl__t1zksw28hb0izniswhi,
  _Speed___get_milesPerHour__impl__yxl3t0 as _Speed___get_milesPerHour__impl__yxl3t010ih676g3jgak,
  _Temperature___init__impl__i36a2t as _Temperature___init__impl__i36a2tw4m6ebev0r1d,
  _Temperature___get_celsius__impl__lhbsrw as _Temperature___get_celsius__impl__lhbsrwuf8reliep8e5,
  _Temperature___get_fahrenheit__impl__xao1tu as _Temperature___get_fahrenheit__impl__xao1tu21fp9sb4ltpuz,
  _Temperature___get_kelvin__impl__us25d7 as _Temperature___get_kelvin__impl__us25d72sz1bdqki59ou,
  _Volume___init__impl__tjrqop as _Volume___init__impl__tjrqop293xbbs3qjofv,
  _Volume___get_cubicFeet__impl__wre3yk as _Volume___get_cubicFeet__impl__wre3ykxjitpvfo2ki5,
  _Volume___get_cubicMeters__impl__6kaaeg as _Volume___get_cubicMeters__impl__6kaaeg3utu7zgy05pgj,
  _Volume___get_cups__impl__tqhzrx as _Volume___get_cups__impl__tqhzrxjta30zi8wv6u,
  _Volume___get_gallons__impl__smxhou as _Volume___get_gallons__impl__smxhou2tdf5455355yu,
  _Volume___get_liquidOunces__impl__d78jyr as _Volume___get_liquidOunces__impl__d78jyr3uqefcew61vh7,
  _Volume___get_liters__impl__yw6tct as _Volume___get_liters__impl__yw6tctrrvnbkop7mp7,
  _Volume___get_milliliters__impl__2fzycw as _Volume___get_milliliters__impl__2fzycw32mmn1wvcv54z,
  _Volume___get_pints__impl__mv7688 as _Volume___get_pints__impl__mv76881i3sc988qvcvg,
  _Volume___get_quarts__impl__2w1hjy as _Volume___get_quarts__impl__2w1hjy2tq282b0j1g1z,
  Companion_instance_5 as Companion_instance2g4pvq9z8og54,
  Companion_instance_1 as Companion_instance3a9vd05w7sq9,
  Companion_instance as Companion_instance1psl1xhmbls3d,
  Companion_instance_7 as Companion_instance2drvy6prp15q0,
  Companion_instance_8 as Companion_instance2dv3afb3e9be1,
  Companion_instance_0 as Companion_instance2ik3kqchmtmbs,
  Companion_instance_3 as Companion_instance2elpx49h5lx9i,
  Companion_instance_9 as Companion_instance1y3kls3ft58mt,
  Companion_instance_6 as Companion_instance1wq80gp5u5pdh,
  Companion_instance_11 as Companion_instance19yah1y07knv1,
  Companion_instance_4 as Companion_instance3h4e1xnva2ie7,
  Companion_instance_10 as Companion_instance2n64nzts3l969,
  Companion_instance_2 as Companion_instance1c4by1hwszuh3,
};
//endregion

//# sourceMappingURL=usefulTypes.mjs.map
